import { isFeatureEnabled, FEATURES } from '~src/features';
import $ from 'jquery';

export const hideUnaccessibleFeatures = () => {
  // isFeatureEnabled(FEATURES.AI_USE_IMAGE_ENHANCEMENT, false).then(
  //   (isEnabled) => {
  //     if (!isEnabled) {
  //       $('#editor-menu-image-faceEnhancement').hide();
  //       return;
  //     }
  //   }
  // );
  isFeatureEnabled(FEATURES.AI_USE_SMILE, false).then((isEnabled) => {
    if (!isEnabled) {
      $('#editor-menu-image-smile').hide();
      return;
    }
  });
  isFeatureEnabled(FEATURES.AI_USE_COLORIZE_BW, false).then((isEnabled) => {
    if (!isEnabled) {
      $('#editor-menu-image-colorizebw').hide();
      return;
    }
  });
  isFeatureEnabled(FEATURES.AI_USE_AUTOCOLOR, false).then((isEnabled) => {
    if (!isEnabled) {
      $('#editor-menu-image-autocolor').hide();
      return;
    }
  });
  isFeatureEnabled(FEATURES.AI_USE_VTO, false).then((isEnabled) => {
    if (!isEnabled) {
      $('#editor-menu-image-change-clothes').hide();
      return;
    }
  });
  isFeatureEnabled(FEATURES.AI_USE_EXPAND, false).then((isEnabled) => {
    if (!isEnabled) {
      $('#editor-menu-image-expand').hide();
      return;
    }
  });
  // isFeatureEnabled(FEATURES.AI_USE_FACE_ENHANCEMENT, false).then(
  //   (isEnabled) => {
  //     if (!isEnabled) {
  //       $('#editor-menu-image-faceEnhancement').hide();
  //       return;
  //     }
  //   }
  // );
  isFeatureEnabled(FEATURES.AI_USE_MAGIC_ERASER, false).then((isEnabled) => {
    if (!isEnabled) {
      $('#editor-menu-image-magic-eraser').hide();
      return;
    }
  });
};
